import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "rowTemplate"]

  connect() {
    if (this.rowsTarget.children.length === 0) this.addRow()
    this.rowsTarget.querySelectorAll("tr").forEach((row) => this.syncRow(row))
  }

  addRow() {
    const fragment = this.rowTemplateTarget.content.cloneNode(true)
    this.rowsTarget.appendChild(fragment)
    this.syncRow(this.rowsTarget.lastElementChild)
  }

  removeRow(event) {
    const row = event.target.closest("tr")

    if (this.rowsTarget.children.length === 1) {
      row.querySelectorAll("input, select").forEach((field) => {
        field.value = ""
        field.disabled = false
        field.setCustomValidity("")
      })
      this.syncRow(row)
      return
    }

    row.remove()
  }

  leaveTypeChanged(event) {
    this.syncLeaveType(event.target.closest("tr"))
  }

  leaveDateChanged(event) {
    const row = event.target.closest("tr")
    this.syncLeaveEndDate(row)
    this.validateLeaveDates(row)
  }

  validate(event) {
    let firstInvalidField = null

    this.rowsTarget.querySelectorAll("tr").forEach((row) => {
      const invalidField = this.validateLeaveDates(row)
      if (!firstInvalidField && invalidField) firstInvalidField = invalidField
    })

    if (firstInvalidField) {
      event.preventDefault()
      firstInvalidField.reportValidity()
    }
  }

  syncRow(row) {
    this.syncLeaveType(row)
    this.syncLeaveEndDate(row)
  }

  syncLeaveType(row) {
    const typeSelect = row.querySelector("[data-leave-type-select]")
    const specialWrapper = row.querySelector("[data-special-leave-wrapper]")
    const specialSelect = row.querySelector("[data-special-leave-type-select]")
    if (!typeSelect || !specialWrapper || !specialSelect) return

    const isSpecial = typeSelect.value === "Ειδικές Άδειες"
    specialWrapper.classList.toggle("d-none", !isSpecial)
    specialSelect.disabled = !isSpecial
    specialSelect.required = isSpecial
    if (!isSpecial) specialSelect.value = ""
  }

  syncLeaveEndDate(row) {
    const startDateField = row.querySelector("[data-leave-start-date-field]")
    const endDateField = row.querySelector("[data-leave-end-date-field]")
    if (!startDateField || !endDateField) return

    if (startDateField.value) {
      endDateField.min = startDateField.value
      if (!endDateField.value || endDateField.value < startDateField.value) {
        endDateField.value = startDateField.value
      }
    } else {
      endDateField.removeAttribute("min")
    }
  }

  validateLeaveDates(row) {
    const startDateField = row.querySelector("[data-leave-start-date-field]")
    const endDateField = row.querySelector("[data-leave-end-date-field]")
    if (!startDateField || !endDateField) return null

    endDateField.setCustomValidity("")

    if (startDateField.value && endDateField.value && endDateField.value < startDateField.value) {
      endDateField.setCustomValidity("Η λήξη δεν μπορεί να είναι πριν από την έναρξη.")
      return endDateField
    }

    return null
  }
}
